import { ipAccessRulesService } from "../../shared/services"
import { ipAccessRulesActions } from "../action-types"
import { DataIpAccessRules } from "../@types"

export const ipAccessRulesChangeModalState = (): ipAccessRulesActions.IIpAccessRulesModalState => ({
  type: ipAccessRulesActions.IP_ACCESS_RULES_MODAL_STATE,
})

export const setIpAccessRulesForUpdate = (
  val: DataIpAccessRules
): ipAccessRulesActions.IGetIpAccessRulesForUpdate => ({
  type: ipAccessRulesActions.GET_IP_ACCESS_RULES_FOR_UPDATE,
  payload: val,
})

export const setIsIpAccessRulesForUpdate = (
  val: boolean
): ipAccessRulesActions.IIsIpAccessRulesForUpdate => ({
  type: ipAccessRulesActions.IS_IP_ACCESS_RULES_FOR_UPDATE,
  payload: val,
})

export const createIpAccessRules = async (
  data: Omit<DataIpAccessRules, "id"> & { id?: number }
) => {
  return await ipAccessRulesService.create(data)
}

export const updateIpAccessRules = async (
  data: Partial<DataIpAccessRules> & { id: number }
) => {
  return await ipAccessRulesService.patch(data?.id!, data)
}

export const refreshTableIpAccessRules = (
  val: boolean
): ipAccessRulesActions.ISwitchIpAccessRulesRefreshTable => ({
  type: ipAccessRulesActions.SWITCH_IP_ACCESS_RULES_REFRESH_TABLE,
  payload: val,
})
